import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "map-project-list map-project-list_type_regions"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "map-project-list"
}
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.regionProjects.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("li", null, "Проектов по регионам:", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.regionProjects, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              onClick: ($event: any) => (_ctx.$emit('regionClick', item))
            }, [
              _createTextVNode(_toDisplayString(_ctx.getRegionName(item)) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(item.countProjects), 1)
            ], 8, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.projects.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("li", null, "Проекты:", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.projects, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              onClick: ($event: any) => (_ctx.onProjectClick(item.id))
            }, _toDisplayString(item.name), 9, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}